import clsx from 'clsx'
import { Checkbox, Col, CreateTableState, Grid, NetworkIcon, Typography } from 'gu-ui-kit'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Recommendations/Benchmarks/benchmarks.module.scss'
import { ArchiveToggleButton, StatusBadge } from 'modules/Recommendations/Benchmarks/subcomponents'

export const useTableConfig = ({ archiveView, checkboxHandleChange, setSeen, ...rest }, data) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()

  const tableConfig = {
    data,
    columns: [
      {
        id: 'checkbox',
        size: 50,
        header: ({
          table: {
            options: {
              meta: { checkedIDs },
            },
            getRowCount,
          },
        }) => (
          <Checkbox
            checked={checkedIDs.length > 0 && checkedIDs.length === getRowCount()}
            onChangeHandle={checkboxHandleChange}
          />
        ),
        cell: ({
          table: {
            options: {
              meta: { checkedIDs },
            },
          },
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              id, // eslint-disable-next-line react/prop-types
              name,
            },
          },
        }) => (
          <Checkbox
            className={styles['benchmarks-list__checkbox']}
            checked={!!checkedIDs.includes(id)}
            onChangeHandle={(e) => e.type === 'change' && checkboxHandleChange(e, id, name)}
          />
        ),
        className: clsx(
          styles['benchmarks-list__cell'],
          styles['benchmarks-list__cell_group-actions'],
        ),
      },
      {
        id: 'name',
        header: t('benchmarks::table.head.name.label'),
        className: clsx(
          styles['benchmarks-list__cell'],
          // styles['benchmarks-list__cell_name'],
          {
            [styles['benchmarks-list__cell_name-archived']]: archiveView,
          },
        ),
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              id, // eslint-disable-next-line react/prop-types
              // eslint-disable-next-line react/prop-types
              name,
              // eslint-disable-next-line react/prop-types
              //month,
              // eslint-disable-next-line react/prop-types
              is_new,
              // eslint-disable-next-line react/prop-types
              account: { type, login },
            },
          },
        }) => (
          <Grid wrap={'nowrap'} alignItems={'center'} gap={16}>
            {!breakpoints.xs && (
              <Grid
                fluid={false}
                alignItems="center"
                justifyContent="center"
                className={clsx(styles['benchmarks-list__icon'], {
                  [styles['benchmarks-list__icon_archive']]: archiveView,
                })}
              >
                <NetworkIcon rounded name={type} width={'40px'} />
              </Grid>
            )}
            <Grid
              className={styles['benchmarks-list__recommendation']}
              fluid={false}
              direction="column"
              alignItems="start"
              justifyContent="start"
              gap={4}
            >
              <a
                onClick={() => !!is_new && setSeen(id)}
                target="_blank"
                className={clsx(styles['benchmarks-list__name'], {
                  [styles['benchmarks-list__name_is-new']]: is_new && !archiveView,
                })}
                href={`/api/app/v1/benchmarks/${id}`}
                rel="noreferrer"
              >
                <Typography variant={'Body-Forms-15'} noMargin color={'Label-Fifth'}>
                  {name}
                </Typography>
              </a>

              <Grid gap={8} alignItems={'center'}>
                {breakpoints.xs && (
                  <Col>
                    <NetworkIcon rounded name={type} width={'24px'} />
                  </Col>
                )}
                <Col>
                  <Grid
                    direction={'column'}
                    gap={4}
                    component={'a'}
                    onClick={() => !!is_new && setSeen(id)}
                    target="_blank"
                    href={`/api/app/v1/benchmarks/${id}`}
                    rel="noreferrer"
                    className={clsx(styles['benchmarks-list__network-login'], {
                      [styles['benchmarks-list__network-login_is-new']]: is_new && !archiveView,
                    })}
                  >
                    <Typography variant={'Body-10'} color={'Label-Secondary'} component={'div'}>
                      {t(`common::accountType.${type}`)}
                    </Typography>
                    <Typography variant={'Body-10'} color={'Label-Secondary'} component={'div'}>
                      {login}
                    </Typography>
                  </Grid>
                </Col>
              </Grid>

              {breakpoints.fb && (
                <StatusBadge
                  status={archiveView ? 'archived' : is_new ? 'new' : ''}
                  className={styles['benchmarks-list__status']}
                />
              )}
            </Grid>
          </Grid>
        ),
      },
      {
        id: 'is_new',
        header: t('benchmarks::table.head.status.label'),
        className: styles['benchmarks-list__cell'],
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              is_new, // eslint-disable-next-line react/prop-types
            },
          },
        }) => {
          return (
            <Grid
              alignItems="start"
              justifyContent="start"
              direction="column"
              l={{
                direction: 'row',
                alignItems: 'center',
                justifyContent: 'between',
              }}
            >
              <Col>
                {!breakpoints.sm && (
                  <StatusBadge
                    status={archiveView ? 'archived' : is_new ? 'new' : ''}
                    className={styles['benchmarks-list__status']}
                  />
                )}
              </Col>
            </Grid>
          )
        },
      },
      {
        id: 'actions',
        header: ' ',

        className: clsx(styles['benchmarks-list__cell'], styles['benchmarks-list__cell_actions']),
        cell: ({
          table: {
            options: {
              meta: { processingIds },
            },
          },
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: {
              // eslint-disable-next-line react/prop-types
              id, // eslint-disable-next-line react/prop-types
              name, // eslint-disable-next-line react/prop-types
              status, // eslint-disable-next-line react/prop-types
            },
          },
        }) => (
          <Grid alignItems="flex-end" justifyContent="flex-end" direction="column">
            <Col>
              <ArchiveToggleButton
                className={styles['benchmarks-list__action-icon-button']}
                action={status === 'active' ? 'archive' : 'activate'}
                id={id}
                login={name}
                processing={processingIds.includes(id)}
              />
            </Col>
          </Grid>
        ),
      },
    ],
    showHeader: data.length > 0,
    state: {
      sorting: [],
      ...rest.state,
    },
    className: styles['benchmarks-list__table'],
    ...rest,
  }

  return { tableState: CreateTableState(tableConfig), tableConfig }
}
